// String utility functions

export function toSlug(value: string): string {
  return String(value)
    .normalize('NFKD') // split accented characters into base + diacritic
    .replace(/[\u0300-\u036f]/g, '') // remove diacritics
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // keep only alphanumerics, spaces, and hyphens
    .replace(/\s+/g, '-') // replace spaces with single hyphen
    .replace(/-+/g, '-') // collapse multiple hyphens
}

/**
 * Replaces spaces after one-letter Czech prepositions with &nbsp;
 * while avoiding HTML tags. Processes only text content.
 */
export function replaceNonBreakingPrepositions(input: string): string {
  const PREPOSITION_REGEX = /\b([ksvzouia])\s+/g

  return input.replace(/(<[^>]+>|[^<]+)/g, (segment) => {
    // If the segment starts with "<", it's an HTML tag → don't touch it
    if (segment.startsWith('<')) {
      return segment
    }

    // Otherwise, it's text → apply the replacement
    return segment.replace(PREPOSITION_REGEX, '$1&nbsp;')
  })
}
